import { TRootState } from "../../reducers/RootReducer";

const selectParameters = (store: TRootState) => store.parameters.data;

export {
  selectParameters
}
